import ElementBoundingRectPositioning from '@intercom/embercom-composer/components/mixins/element-bounding-rect-positioning';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import Em from 'ember';
export default Em.Object.extend(ElementBoundingRectPositioning, {
  hoverAreaPadding: {},
  editorDimensions: {},
  $editor: null,
  mouseX: null,
  mouseY: null,
  left: reads('editorDimensions.emailTemplateOffsetLeft'),
  top: reads('closestInsertionPoint.blockInsertionPoint'),
  insertionIndex: reads('closestInsertionPoint.index'),
  insertionPointsCount: reads('insertionPoints.length'),
  editorLeft: reads('editorDimensions.left'),
  editorHeight: reads('editorDimensions.height'),
  editorWidth: reads('editorDimensions.width'),
  editorPositionTop: reads('editorDimensions.positionTop'),
  editorPositionLeft: reads('editorDimensions.positionLeft'),
  topTemplateOffset: reads('editorDimensions.emailTemplateOffsetTop'),
  leftTemplateOffset: reads('editorDimensions.emailTemplateOffsetLeft'),
  willDestroy() {
    this.set('insertionPoints', null);
    this.set('$editor', null);
  },
  updateMouseCoordinates(mouseX, mouseY) {
    let insertionPoints = [];
    if (this._cursorIsNearEditor(mouseX, mouseY)) {
      insertionPoints = this._getInsertionPoints();
    }
    this.setProperties({
      mouseX,
      mouseY,
      insertionPoints
    });
    this._showHoverDebugOutlines();
  },
  closestInsertionPoint: Em.computed('mouseY', 'insertionPoints', function () {
    let mouseY = this.get('mouseY');
    if (mouseY === null) {
      return null;
    }
    return this._findClosestInsertionPoint(mouseY, this.get('insertionPoints'));
  }),
  hoveredBlock: Em.computed('mouseY', 'insertionPoints', 'closestInsertionPoint', function () {
    return this._findHoveredBlock(this.get('mouseY'), this.get('insertionPoints'), this.get('closestInsertionPoint'));
  }),
  isWithinViewport: Em.computed('closestInsertionPoint', function () {
    return this._isInsertionPointInViewport(this.get('closestInsertionPoint'));
  }),
  isWithinLeftPadding: Em.computed('mouseX', function () {
    return this._isPointerInLeftPadding(this.get('mouseX'));
  }),
  isWithinRightPadding: Em.computed('mouseX', function () {
    return this._isPointerInRightPadding(this.get('mouseX'));
  }),
  _getBlocks($editor) {
    if (!$editor || !$editor.length) {
      return [];
    }
    return $editor.children();
  },
  _getInsertionPoints() {
    let $editor = this.get('$editor');
    let $blocks = this._getBlocks($editor);
    let topTemplateOffset = this.get('topTemplateOffset');
    let editorBoundingRect = $editor[0].getBoundingClientRect();
    let $firstBlock = $($blocks[0]);
    let firstBlockBoundingRect = $blocks[0].getBoundingClientRect();
    let positionRelativeToEditor = (Math.abs(firstBlockBoundingRect.top) - Math.abs(editorBoundingRect.top)) / 2;
    let initialInsertionPoint = {
      index: 0,
      viewportLocation: firstBlockBoundingRect.top,
      blockInsertionPoint: Math.round(positionRelativeToEditor + topTemplateOffset),
      block: $firstBlock
    };
    let insertionPoints = [initialInsertionPoint];
    for (let i = 0; i < $blocks.length; i++) {
      let currentBlock = $($blocks[i]);
      let blockBoundingRect = $blocks[i].getBoundingClientRect();
      let blockInsertionPoint = this._findBlockInsertPoint($blocks, i, $editor[0]);
      insertionPoints.push({
        index: i + 1,
        viewportLocation: blockBoundingRect.bottom,
        blockInsertionPoint: Math.round(blockInsertionPoint + topTemplateOffset),
        block: currentBlock
      });
    }
    return insertionPoints;
  },
  _findBlockInsertPoint($blocks, index, editorElement) {
    let currentBlock = $blocks[index];
    let bottomOfBlock = this.verticalDifferenceBetweenElements(editorElement, currentBlock, {
      measureToBottomOfSecondBlock: true
    });
    let topOfNextBlock;
    if ($blocks[index + 1]) {
      let nextBlock = $blocks[index + 1];
      topOfNextBlock = this.verticalDifferenceBetweenElements(editorElement, nextBlock, {
        measureToBottomOfSecondBlock: false
      });
      return (bottomOfBlock + topOfNextBlock) / 2;
    } else {
      return bottomOfBlock;
    }
  },
  _cursorIsNearEditor(mouseX, mouseY) {
    let editorBoundingRect = this.get('$editor')[0].getBoundingClientRect();
    let editorPadding = this.get('hoverAreaPadding');
    let insideTop = mouseY >= editorBoundingRect.top - editorPadding.top;
    let insideRight = mouseX <= editorBoundingRect.left + editorBoundingRect.width + editorPadding.right;
    let insideBottom = mouseY <= editorBoundingRect.bottom + editorPadding.bottom;
    let insideLeft = mouseX >= editorBoundingRect.left - editorPadding.left;
    return insideTop && insideRight && insideBottom && insideLeft;
  },
  _findClosestInsertionPoint(mouseY, insertionPoints) {
    if (!insertionPoints || insertionPoints.length === 0) {
      return null;
    }
    return insertionPoints.reduce(function (prev, curr) {
      let currDistance = Math.abs(curr.viewportLocation - mouseY);
      let prevDistance = Math.abs(prev.viewportLocation - mouseY);
      return currDistance < prevDistance ? curr : prev;
    });
  },
  _findHoveredBlock(mouseY, insertionPoints, closestInsertionPoint) {
    let hoveredBlock;
    let mouseAboveClosest = mouseY > closestInsertionPoint.viewportLocation;
    let isNotLast = closestInsertionPoint.index + 1 < insertionPoints;
    if (mouseAboveClosest && isNotLast) {
      hoveredBlock = insertionPoints[closestInsertionPoint.index + 1].block;
    } else {
      hoveredBlock = closestInsertionPoint.block;
    }
    return hoveredBlock;
  },
  _isInsertionPointInViewport(insertionPoint) {
    if (!insertionPoint) {
      return false;
    }
    let blockInsertionPoint = insertionPoint.blockInsertionPoint;
    let isBelowTopOfViewport = blockInsertionPoint >= 0;
    let bottomOfViewport = this.get('editorHeight') + this.get('topTemplateOffset');
    let isAboveBottomOfViewport = blockInsertionPoint <= bottomOfViewport;
    return isBelowTopOfViewport && isAboveBottomOfViewport;
  },
  _isPointerInLeftPadding(mouseX) {
    let editorLeft = this.get('editorLeft');
    let paddingStart = editorLeft - this.get('hoverAreaPadding').left;
    let isAfterPaddingStart = mouseX > paddingStart;
    let isBeforePaddingEnd = mouseX < editorLeft;
    return isAfterPaddingStart && isBeforePaddingEnd;
  },
  _isPointerInRightPadding(mouseX) {
    let paddingStart = this.get('editorLeft') + this.get('editorWidth');
    let paddingEnd = paddingStart + this.get('hoverAreaPadding').right;
    let isAfterPaddingStart = mouseX > paddingStart;
    let isBeforePaddingEnd = mouseX < paddingEnd;
    return isAfterPaddingStart && isBeforePaddingEnd;
  },
  _showHoverDebugOutlines() {
    let hoverCoordinates = this.get('hoverCoordinates');
    if (this.get('showDebugOutlines') && hoverCoordinates) {
      let hoveredBlock = hoverCoordinates.hoveredBlock;
      $('#dynamic-hover-block-overlay').css({
        top: this.get('topTemplateOffset') + hoveredBlock.position().top - this.get('editorPositionTop'),
        left: this.get('leftTemplateOffset') + hoveredBlock.position().left - this.get('editorPositionLeft'),
        width: hoveredBlock.outerWidth(true),
        height: hoveredBlock.outerHeight(true),
        'outline-color': hoverCoordinates.isWithinViewport ? 'purple' : 'crimson'
      });
      $('#dynamic-hover-insertion-overlay').css({
        top: hoverCoordinates.top,
        left: hoverCoordinates.left,
        'background-color': hoverCoordinates.isWithinViewport ? 'purple' : 'crimson'
      });
      $('#dynamic-hover-insertion-index').css({
        top: hoverCoordinates.top,
        left: hoverCoordinates.left,
        'background-color': hoverCoordinates.isWithinViewport ? 'purple' : 'crimson'
      });
    }
  }
});